import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";

import "./style.scss";
import { SURVEY_TYPE } from "../../../shared/utils/constant";
import { compose } from "recompose";
import { GetLatestRoadSurveyedFile } from "../../../services/actions/RoadAction";
import { setTableData, selectPointRow, selectLineRow } from "../../../services/actions/GisAction";
import { Button, ButtonGroup } from "@material-ui/core";

const GisDataTable = ({ setTableData, selectPointRow, selectLineRow }) => {
  const [surveyType, setSurveyType] = useState("");
  const [selectedPointRow, setSelectedPointRow] = useState(null);
  const [selectedLineRow, setSelectedLineRow] = useState([]);
  const dispatch = useDispatch();
  const { lineRowData } = useSelector((state) => ({
    lineRowData: state.gis.lineRowData,
  }));

  // 行の選択情報を初期化する
  const resetRowSelect = () => {
    setSelectedPointRow(null);
    setSelectedLineRow([]);
    selectPointRow(null);
    selectLineRow([]);
  }

  // state変数
  let stateForBottom = useSelector((state) => ({
    surveyedMapType: state.gis.surveyedMapType,
    tableData: state.gis.tableData,
    surfaces: state.surface.surfaces,
    userFilter: state.road.userFilter
  }));
  let userFilter = stateForBottom.userFilter;

  useEffect(() => {
    const getData = async (userFilter) => {
      const data = await dispatch(GetLatestRoadSurveyedFile(userFilter));
      if (
        data && data[0]) {
        setSurveyType(SURVEY_TYPE[data[0].type].value);
      }
    };

    if (userFilter != null) {
      getData(userFilter);
    }
  }, [userFilter]);

  let pointTableData = [];
  let lineTableData = [];
  let columnsPointArray = [];
  let columnsLineArray = [];
  const levelColumnsStringsArray_0 = [
    "Level1(ml)",
    "Level2(ml)",
    "Level3(ml)",
    "Level4(ml)",
    "Level5(ml)",
    "Level6(ml)",
    "Level7(ml)"
  ];
  const levelColumnsStringsArray_12 = [
    "Level1[{min}-{max}](ml)",
    "Level2[{min}-{max}](ml)",
    "Level3[{min}-{max}](ml)",
    "Level4[{min}-{max}](ml)",
    "Level5[{min}-{max}](ml)",
    "Level6[{min}-{max}](ml)",
    "Level7[{min}-{max}](ml)"
  ];
  let levelColumnsStringsArray;
  if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
    levelColumnsStringsArray = levelColumnsStringsArray_12;
  } else {
    levelColumnsStringsArray = levelColumnsStringsArray_0;
  }

  let surveyedMapType = stateForBottom.surveyedMapType;
  let tableData = stateForBottom.tableData;
  const surfaces = stateForBottom.surfaces;
  if (!Array.isArray(tableData)) return null;
  let _data = [...tableData];
  let data = _data.map((item, idx) => {
    let _coordinates = [...item._geometry.coordinates];
    return Object.assign({}, item.properties, { no: idx + 1, point: _coordinates.toReversed() });
  });
  let levelRanges = [];
  if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
    surfaces.forEach((surface) => {
      if (surface.rangeValue != null) {
        levelRanges.push(JSON.parse(surface.rangeValue));
      }
    });
    for (var i = 0; i < levelColumnsStringsArray.length; i++) {
      if (i >= levelRanges.length) {
        continue;
      }
      levelColumnsStringsArray[i] = levelColumnsStringsArray[i].replace("{min}-{max}", levelRanges[i][0] + "-" + levelRanges[i][1]);
    }
  } else {
    surfaces.forEach((surface) => {
      if (surface.value != null) {
        levelRanges.push(parseInt(surface.value, 10));
      }
    });
  }

  if (surveyedMapType === "point") {
    data.forEach((row, idx) => {
      if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
        // distressAverageを四捨五入して整数に
        let score = Math.round(row["distressAverage"]);
        row["distressAverage"] = score;
        // 7-tier列の値決定
        let tier7 = 0;

        for (let i = 0; i < levelRanges.length; i++) {
          if (i == 0) {
            if (score >= levelRanges[i][0]) {
              tier7 = i + 1;
              break;
            }
          } else if (score >= levelRanges[i][0] && score <= levelRanges[i][1]) {
            tier7 = i + 1;
            break;
          }
        }
        if (tier7 == 0) {
          tier7 = levelRanges.length + 1;
        }
        row["7-tier"] = tier7;
      }
      // SPM-IRI列の値設定
      const spmIri = Math.round(parseFloat(row["spmIri"]));
      if (isNaN(spmIri)) {
        row["spmIri"] = "";
      } else {
        row["spmIri"] = spmIri;
      }
    });

    // column情報の追加
    if (columnsPointArray.length === 0) {
      if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
        columnsPointArray = [
          { title: "#", field: "no" },
          { title: "VideoDate", field: "surveyedDate", type: "datetime" },
          { title: "RoadName", field: "roadName" },
          {
            title: "SPM-PCI", field: "distressAverage",
            cellStyle: (cellData) => {
              let cellStyle = { textAlign: "center" };
              for (let i = 0; i < levelRanges.length; i++) {
                if (i == 0) {
                  if (cellData >= levelRanges[i][0] && surfaces.length > i) {
                    cellStyle =  { backgroundColor: surfaces[i]["color"], color: "#FFFFFF", textAlign: "center" };
                    break;
                  }
                } else if (cellData >= levelRanges[i][0] && cellData <= levelRanges[i][1] && surfaces.length > i) {
                    cellStyle = { backgroundColor: surfaces[i]["color"], color: "#FFFFFF", textAlign: "center" };
                    break;
                }
              }
              return cellStyle;
            }
          },
          {
            title: "7-tier", field: "7-tier",
            cellStyle: (cellData) => {
              let tmpVal = Math.round(cellData);
              if (tmpVal > 0 && surfaces.length >= tmpVal) {
                return { backgroundColor: surfaces[tmpVal - 1]["color"], color: "#FFFFFF", textAlign: "center" };
              }
              return { textAlign: "center" };
            }
          },
          {
            title: "SPM-IRI", field: "spmIri",
            cellStyle: (cellData) => {
              if (cellData === "") {
                return { color: "#000000" }
              }
              if (cellData < 250) {
                return { backgroundColor: "#00B050", color: "#FFFFFF", textAlign: "center"  }
              } else if (cellData >= 250 && cellData < 500) {
                return { backgroundColor: "#92D050", color: "#FFFFFF", textAlign: "center"  }
              } else if (cellData >= 500 && cellData < 750) {
                return { backgroundColor: "#ED7D31", color: "#FFFFFF", textAlign: "center"  }
              } else {
                return { backgroundColor: "#FF0000", color: "#FFFFFF", textAlign: "center"  }
              }
            }
          },
          { title: "Surface", field: "surface" },
          { title: "Coordinates", field: "point", hidden: true } // 行クリックイベント用
        ];
      } else if (surveyType === SURVEY_TYPE.SPM_PASER.value) {
        columnsPointArray = [
          { title: "#", field: "no" },
          { title: "VideoDate", field: "surveyedDate", type: "datetime" },
          { title: "RoadName", field: "roadName" },
          {
            title: "5-tier", field: "distressAverage",
            cellStyle: (cellData) => {
              let tmpVal = Math.round(cellData);
              if (tmpVal > 0 && surfaces.length >= tmpVal) {
                return { backgroundColor: surfaces[tmpVal - 1]["color"], color: "#FFFFFF", textAlign: "center" };
              }
              return { textAlign: "center" };
            }
          },
          {
            title: "SPM-IRI", field: "spmIri",
            cellStyle: (cellData) => {
              if (cellData === "") {
                return { color: "#000000" }
              }
              if (cellData < 250) {
                return { backgroundColor: "#00B050", color: "#FFFFFF", textAlign: "center" }
              } else if (cellData >= 250 && cellData < 500) {
                return { backgroundColor: "#92D050", color: "#FFFFFF", textAlign: "center" }
              } else if (cellData >= 500 && cellData < 750) {
                return { backgroundColor: "#ED7D31", color: "#FFFFFF", textAlign: "center" }
              } else {
                return { backgroundColor: "#FF0000", color: "#FFFFFF", textAlign: "center" }
              }
            }
          },
          { title: "Surface", field: "surface" },
          { title: "Coordinates", field: "point", hidden: true } // 行クリックイベント用
        ];
      }
    }
    pointTableData = data;
  } else if (surveyedMapType === "line") {
    // 表示上限値
    let graphMaxValue = 0;
    const graphMaxWidth = 90;

    data.forEach((row, idx) => {
      // distressAverageを四捨五入して整数に
      let score = Math.round(row["distressAverage"]);
      row["distressAverage"] = score;
      // Length(ml)の表示値算出
      let length = parseFloat(row["totalPoint"]);
      length = Math.round((10 * length) / 160.9344) / 10;
      row["totalPoint"] = length;
      // 各損傷度の表示値算出
      let level1 = parseFloat(row["level1"]);
      row["level1"] = Math.round((10 * level1) / 160.9344) / 10;
      level1 = isNaN(level1) ? 0 : level1;
      let level2 = parseFloat(row["level2"]);
      row["level2"] = Math.round((10 * level2) / 160.9344) / 10;
      level2 = isNaN(level2) ? 0 : level2;
      let level3 = parseFloat(row["level3"]);
      row["level3"] = Math.round((10 * level3) / 160.9344) / 10;
      level3 = isNaN(level3) ? 0 : level3;
      let level4 = parseFloat(row["level4"]);
      row["level4"] = Math.round((10 * level4) / 160.9344) / 10;
      level4 = isNaN(level4) ? 0 : level4;
      let level5 = parseFloat(row["level5"]);
      row["level5"] = Math.round((10 * level5) / 160.9344) / 10;
      level5 = isNaN(level5) ? 0 : level5;
      let level6 = parseFloat(row["level6"]);
      row["level6"] = Math.round((10 * level6) / 160.9344) / 10;
      level6 = isNaN(level6) ? 0 : level6;
      let level7 = parseFloat(row["level7"]);
      row["level7"] = Math.round((10 * level7) / 160.9344) / 10;
      level7 = isNaN(level7) ? 0 : level7;

      if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
        let level4_7 = level4 + level5 + level6 + level7;
        row["level4_7"] = Math.round((10 * level4_7) / 160.9344) / 10;
        level4_7 = isNaN(level4_7) ? 0 : level4_7;
        graphMaxValue = Math.max(level1, level2, level3, level4, level5, level6, level7, level4_7, graphMaxValue);
      } else if (surveyType === SURVEY_TYPE.SPM_PASER.value) {
        let level4_5 = level4 + level5;
        row["level4_5"] = Math.round((10 * level4_5) / 160.9344) / 10;
        level4_5 = isNaN(level4_5) ? 0 : level4_5;
        graphMaxValue = Math.max(level1, level2, level3, level4, level5, level6, level7, level4_5, graphMaxValue);
      }
    });
    graphMaxValue =  Math.round((10 * graphMaxValue) / 160.9344) / 10;

    // セル描画処理
    const getDataColumnRenderFunction = (field, color) => {
      return (rowData) => {
        let rowValue = rowData[field];
        if (rowValue == null) {
          return '';
        } else if (typeof rowValue !== 'number') {
          return rowValue;
        } else if (isNaN(rowValue)) {
          return 'NaN';
        }
        
        let barLength = Math.min(rowValue, graphMaxValue) / graphMaxValue * graphMaxWidth;
        if (barLength < 0) {
          barLength = 0;
        }
        barLength = barLength + 'px';
        const barBorder = `1px solid ${color}`;
        const barBackground = `linear-gradient(to right, ${color}, rgba(255, 255, 255, 0))`;
        return (
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, margin: 0, padding: 0, border: barBorder, width: barLength, overflow: 'hidden', background: barBackground }}>&nbsp;</div>
            <div style={{ padding: 0, margin: 0, textAlign: 'right' }}>{rowValue}</div>
          </div>
        );
      }
    };

    // column情報の追加
    if (columnsLineArray.length === 0) {
      if (surveyType === SURVEY_TYPE.SPM_PCI.value || surveyType === SURVEY_TYPE.SPM_PCI_DP.value) {
        if (surfaces.length < 7) {
          columnsLineArray = [
            { title: "#", field: "no" },
            { title: "RoadName", field: "roadName" },
            { title: "Length(ml)", field: "totalPoint" },
            { title: "Ave.Score", field: "distressAverage" }
          ];
        } else {
          columnsLineArray = [
            { title: "#", field: "no" },
            { title: "RoadName", field: "roadName" },
            { title: "Length(ml)", field: "totalPoint" },
            { title: levelColumnsStringsArray[0], field: "level1", headerStyle: { backgroundColor: surfaces[0]["color"] }, render: getDataColumnRenderFunction("level1", surfaces[0]["color"]) },
            { title: levelColumnsStringsArray[1], field: "level2", headerStyle: { backgroundColor: surfaces[1]["color"] }, render: getDataColumnRenderFunction("level2", surfaces[1]["color"]) },
            { title: levelColumnsStringsArray[2], field: "level3", headerStyle: { backgroundColor: surfaces[2]["color"] }, render: getDataColumnRenderFunction("level3", surfaces[2]["color"]) },
            { title: levelColumnsStringsArray[3], field: "level4", headerStyle: { backgroundColor: surfaces[3]["color"] }, render: getDataColumnRenderFunction("level4", surfaces[3]["color"]) },
            { title: levelColumnsStringsArray[4], field: "level5", headerStyle: { backgroundColor: surfaces[4]["color"] }, render: getDataColumnRenderFunction("level5", surfaces[4]["color"]) },
            { title: levelColumnsStringsArray[5], field: "level6", headerStyle: { backgroundColor: surfaces[5]["color"] }, render: getDataColumnRenderFunction("level6", surfaces[5]["color"]) },
            { title: levelColumnsStringsArray[6], field: "level7", headerStyle: { backgroundColor: surfaces[6]["color"] }, render: getDataColumnRenderFunction("level7", surfaces[6]["color"]) },
            { title: "Level4-7(ml)", field: "level4_7", headerStyle: { backgroundColor: "#4C93D9" }, render: getDataColumnRenderFunction("level4_7", '#4C93D9') },
            {
              title: "Ave.Score", field: "distressAverage",
              cellStyle: (cellData) => {
                let cellStyle = { textAlign: "center" };
                for (let i = 0; i < levelRanges.length; i++) {
                  if (i == 0) {
                    if (cellData >= levelRanges[i][0]) {
                      cellStyle = { backgroundColor: surfaces[i]["color"], color: "#FFFFFF", textAlign: "center" };
                      break;
                    }
                  } else if (cellData >= levelRanges[i][0] && cellData <= levelRanges[i][1]) {
                    cellStyle = { backgroundColor: surfaces[i]["color"], color: "#FFFFFF", textAlign: "center" };
                    break;
                  }
                }
                return cellStyle;
              }
            },
          ];
        }
      } else if (surveyType === SURVEY_TYPE.SPM_PASER.value) {
        columnsLineArray = [
          { title: "#", field: "no" },
          { title: "RoadName", field: "roadName" },
          { title: "Length(ml)", field: "totalPoint" },
          { title: levelColumnsStringsArray[0], field: "level1", headerStyle: { backgroundColor: surfaces[0]["color"] }, render: getDataColumnRenderFunction("level1", surfaces[0]["color"]) },
          { title: levelColumnsStringsArray[1], field: "level2", headerStyle: { backgroundColor: surfaces[1]["color"] }, render: getDataColumnRenderFunction("level2", surfaces[1]["color"]) },
          { title: levelColumnsStringsArray[2], field: "level3", headerStyle: { backgroundColor: surfaces[2]["color"] }, render: getDataColumnRenderFunction("level3", surfaces[2]["color"]) },
          { title: levelColumnsStringsArray[3], field: "level4", headerStyle: { backgroundColor: surfaces[3]["color"] }, render: getDataColumnRenderFunction("level4", surfaces[3]["color"]) },
          { title: levelColumnsStringsArray[4], field: "level5", headerStyle: { backgroundColor: surfaces[4]["color"] }, render: getDataColumnRenderFunction("level5", surfaces[4]["color"]) },
          { title: "Level4+5(ml)", field: "level4_5", headerStyle: { backgroundColor: "#4C93D9" }, render: getDataColumnRenderFunction("level4_5", "#4C93D9") },
          {
            title: "Ave.Score", field: "distressAverage",
            cellStyle: (cellData) => {
              let tmpVal = Math.round(cellData);
              let cellStyle = { textAlign: "center" };
              for (let i = 0; i < levelRanges.length; i++) {
                if (tmpVal == levelRanges[i] && surfaces.length > i) {
                  cellStyle =  { backgroundColor: surfaces[i]["color"], color: "#FFFFFF", textAlign: "center" };
                  break;
                }
              }
              return cellStyle;
            }
          },
        ];
      }
    }
    lineTableData = data;
  }

  return (
    <div className="data-table-area">
      {surveyedMapType === "point" ? (
        <MaterialTable
          title={""}
          columns={columnsPointArray}
          data={pointTableData}
          onRowClick={((evt, currentSelectedRow) => {
            setSelectedPointRow(currentSelectedRow._id);
            selectPointRow(currentSelectedRow);
          })}
          options={{
            headerStyle: {
              backgroundColor: "#FFC000",
              color: "#FFFFFF",
              fontWeight: "bold"
            },
            maxBodyHeight: "calc(50vh - 100px)",
            sorting: true,
            toolbar: false,
            paging: false,
            sortArrow: 'desc',
            draggable: false,
            debounceInterval: 500,
            rowStyle: rowData => ({
              backgroundColor: (selectedPointRow == rowData._id) ? "#FFF2CD" : "#FFFFFF"
            })
          }}
        />
      ) : (
        <MaterialTable
          title={""}
          columns={columnsLineArray}
          data={lineTableData}
          onRowClick={((evt, currentSelectedRow) => {
            // 選択行IDの保持
            let preSelectedRows = selectedLineRow;
            let removeFlg = false;
            if (!preSelectedRows.includes(currentSelectedRow._id)) {
              preSelectedRows.push(currentSelectedRow._id);
            } else {
              // 再選択時は選択を解除
              preSelectedRows = preSelectedRows.filter(item => item !== currentSelectedRow._id);
              removeFlg = true;
            }
            setSelectedLineRow(preSelectedRows);
            // 選択済みラインの保持
            let preSelectedLineRows = [];
            if (lineRowData.length != null) {
              for (let r = 0; r < lineRowData.length; r++) {
                preSelectedLineRows.push(lineRowData[r]);
              }
            }
            if (!removeFlg) {
              preSelectedLineRows.push(currentSelectedRow);
            } else {
              preSelectedLineRows = preSelectedLineRows.filter(item => item._id !== currentSelectedRow._id);
            }
            selectLineRow(preSelectedLineRows);
          }
          )}
          options={{
            headerStyle: {
              backgroundColor: "#FFC000",
              color: "#FFFFFF",
              fontWeight: "bold"
            },
            maxBodyHeight: "calc(50vh - 100px)",
            sorting: true,
            toolbar: false,
            paging: false,
            sortArrow: 'desc',
            draggable: false,
            debounceInterval: 500,
            rowStyle: rowData => ({
              backgroundColor: (selectedLineRow.includes(rowData._id)) ? "#FFF2CD" : "#FFFFFF"
            })
          }}
        />
      )}
      <ButtonGroup size="small" className="off-focus" style={{ position: 'absolute', top: '0px', right: '-100px', display: 'hidden' }}>
        <Button
          id="bottomFilterResetBtn"
          className="off-focus"
          style={{ display: 'none' }}
          onClick={() => resetRowSelect()}>
          RESET
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default compose(
  connect(
    (state) => ({
      tableData: state.gis.tableData,
      pointRowData: state.gis.selectPointRow,
      lineRowData: state.gis.selectLineRow,
    }),
    (dispatch) => ({
      setTableData: (data) => dispatch(setTableData(data)),
      selectPointRow: (data) => dispatch(selectPointRow(data)),
      selectLineRow: (data) => dispatch(selectLineRow(data)),
    })
  )
)(GisDataTable);
